import React from 'react'
import Paper from '@mui/material/Paper';

import api from '../../API/api';
import { useNavigate } from 'react-router-dom';



const Colleges = (props) => {
    const navigation = useNavigate();


    return (
        <>
            <div>
                <Paper elevation={3}>
                    <div className="p-5">
                        <div className="text-center pb-4">
                            <h2>OUR SCHOOLS</h2>
                        </div>


                        <div className="row justify-content-center">
                            {props.schools && props.schools.map((sch, index) =>
                            (
                                <div key={index} className="col-md-3 text-center p-2">
                                    <Paper className={`border border-primary ${index % 2 ? 'bg-primary text-white ' : ''}`} onClick={() => navigation(`school/${sch.slug}/${sch.id}`)} elevation={6}>
                                        <div className='p-md-3 p-1 school-box d-flex align-items-center' style={{cursor: 'pointer'}}>
                                            <div className="row align-items-center">
                                                <div className="col-3">
                                                    <div className={`school-icon ${index % 2 ? 'bg-white' : 'bg-primary text-white '}`}>
                                                        <img src={`${process.env.REACT_APP_BACKEND}assets/schools/icon/${sch.icon}`} alt="pews schools logo" className='col-8' />
                                                    </div>
                                                </div>
                                                <div className="col-9">
                                                    <div>
                                                        <b>{sch.schoolName}</b>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </Paper>
                                </div>

                            ))}
                        </div>


                    </div>
                </Paper>
            </div>
        </>
    )
}

export default Colleges;